import React, { Component } from 'react';
import { Form, Row, Col} from 'react-bootstrap';
import { getDateDisplayValue } from '../../backend/UIUtils';
import { translate } from "react-i18next";


class DateChoice extends Component {

  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
    this.getItemDateDisplayValue = this.getItemDateDisplayValue.bind(this);
    

    this.state = {
      item: this.props.item,
      onClickHandler: this.props.onClickHandler
    };
  }

  handleChange(e) {
    var value = e.target.checked ? 'YES' : 'NO';
    this.props.onClickHandler(value, this.props.item.dateChoiceId);
  };

  

  render() {
    const { t } = this.props;
    let item = this.state.item;
    let ultimate = item.ultimate;
    let itemLabel = this.getItemDateDisplayValue(item);
    if(item.booked){
      itemLabel = itemLabel +" "+ t("booked");
    }
    return <div>
      <Row className={ultimate ?  "greenBg  ": ""}>

        <Col >
          <div key={`inline-${item.startDate}`} className={ (item.responseType === 'YES' ? 'bold text-success ' : 'bold')} >
         
          <Form.Check label={itemLabel} id={`inline-1`} checked={item.responseType === 'YES'} onChange={this.handleChange} disabled={item.disabled} />
          </div>
        </Col>
       
      </Row>
      {ultimate ?
      <Row className={ultimate ?  "mb-3 greenBg ": "mb-3 "}  >
        <Col lg={4}>&nbsp;</Col>
        <Col lg={8}>
          <Form.Label >{t("finalAusgewaehlt")} <span className="fa fa-crown s24 text-success" /></Form.Label>
        </Col>
       
      </Row>
      :
      ""
      }

     

      {item.comment ?
        <Row className={ultimate ?  "mb-3 greenBg ": "mb-3 "}  >
          <Col lg={4}>&nbsp;</Col>
          <Col lg={8}>
          <Form.Label >{item.comment}</Form.Label>
          </Col>
        </Row>
        :
        ""
      }
    </div>

  }

  getItemDateDisplayValue(item){
    var full_options = { weekday: 'short', day: 'numeric', month: 'short', year: '2-digit' , hour:'numeric', minute:'numeric'};
    var hour_options = { hour:'numeric', minute:'numeric'};
    if(!item.startDate && !item.endDate){
      return "?"
    }
    if (item.startDate  && !item.endDate) {
			return getDateDisplayValue(item.startDate, full_options);
    }
    if (!item.startDate  && item.endDate) {
			return "? -" + getDateDisplayValue(item.endDate, full_options);
    }
    if (item.sameDay) {
      return  getDateDisplayValue(item.startDate, full_options) + " - "+   new  Date(item.endDate).toLocaleTimeString('de-DE', hour_options)
  	}
		return  getDateDisplayValue(item.startDate, full_options) + " - " + getDateDisplayValue(item.endDate, full_options);
  }

  


}

export default translate("translations")(DateChoice);
